export enum UserRole {
    OWNER = 'owner',
    ADMIN = 'admin',
    STAFF = 'staff'
}
